/**
 * Redirect Types
 *
 * Type definitions for application routing and redirection logic
 */

import type { UserRole } from './role.types';
import type { AuthTokens } from './auth.types';

/**
 * Target application enum
 */
export enum TargetApp {
  OPERATIONS = 'OPERATIONS',
  CARBON_ACCOUNTING = 'CARBON_ACCOUNTING',
  SUPPLY_CHAIN = 'SUPPLY_CHAIN',
  ESG = 'ESG',
  VENDOR = 'VENDOR',
}

/**
 * Application configuration
 */
export interface AppConfig {
  /** Base URL of the application */
  url: string;
  /** Login path (e.g., '/login', '/supply-chain-login') */
  loginPath: string;
  /** Human-readable name */
  name: string;
  /** App identifier */
  app: TargetApp;
}

/**
 * Redirect context - all information needed to determine redirect destination
 */
export interface RedirectContext {
  /** Authentication tokens */
  tokens: AuthTokens;
  /** User's roles */
  roles: UserRole[];
  /** Original referrer URL from query params (full URL including path) */
  referrerUrl?: string | null;
}

/**
 * Redirect result
 */
export interface RedirectResult {
  /** Full redirect URL with tokens */
  url: string;
  /** Target application */
  app: TargetApp;
  /** Whether this was a custom referrer redirect */
  isCustomReferrer: boolean;
}

/**
 * Role to app mapping for default redirects
 */
export type RoleToAppMap = Record<TargetApp, UserRole[]>;
